export default __webpack_public_path__ + "static/HalvarBreit-Bd-9447538d3fca33338789446655b20cdd.woff2";